import { atom } from "recoil";

export const defaultResetPasswordFormState = {
    usrId : "",
    usrPwd : "",
    newUsrPwd : "", 
    newUsrPwdCheck : ""
};
const resetPasswordFormState = atom<{
    usrId: string;
    usrPwd: string;
    newUsrPwd: string;
    newUsrPwdCheck : string;
}>({
    key: "resetPasswordFormState",
    default: defaultResetPasswordFormState,
});

export default resetPasswordFormState;
